import StackdriverErrorReporter from "stackdriver-errors-js";

// Exists in this file because exporting from index.tsx causes jest errors
export const ErrorHandler = new StackdriverErrorReporter();
